import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  HiOutlineClipboardList,
  HiOutlineUserGroup,
  HiOutlineBadgeCheck,
  HiOutlineCreditCard,
} from "react-icons/hi";
import FeedbackContext from "../../context/cmscontext";
import StepGraphic from "./StepGraphics";
import "./style.css";

const STEP_DURATION_MS = 4500;

const trim = (str) => (str || "").trim();

const stripStepPrefix = (title) => trim(title).replace(/^\d+\.\s*/, "");

const STEPS = [
  {
    titleKey: "Profile_your_car_heading",
    descKey: "Profile_your_car_desp",
    icon: HiOutlineClipboardList,
  },
  {
    titleKey: "We_do_heading",
    descKey: "We_do_heading_desp",
    icon: HiOutlineUserGroup,
  },
  {
    titleKey: "Get_your_best_heading",
    descKey: "Get_your_best_desp",
    icon: HiOutlineBadgeCheck,
  },
  {
    titleKey: "Complete_your_heading",
    descKey: "Complete_your_desp",
    icon: HiOutlineCreditCard,
  },
];

function Howwork() {
  const { feedback } = useContext(FeedbackContext);
  const home_page = feedback.home_page;
  const [activeStep, setActiveStep] = useState(0);
  const [paused, setPaused] = useState(false);
  const [playKey, setPlayKey] = useState(0);

  const selectStep = useCallback((index) => {
    setActiveStep(index);
    setPlayKey((k) => k + 1);
  }, []);

  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setInterval(() => {
      setActiveStep((current) => (current + 1) % STEPS.length);
      setPlayKey((k) => k + 1);
    }, STEP_DURATION_MS);
    return () => window.clearInterval(timer);
  }, [paused, activeStep]);

  return (
    <div className="how-it-works how_wrap pi-process-inner">
      <header className="pi-section-head">
        <p className="pi-label">Process</p>
        <h2>{trim(home_page.How_Works_heading)}</h2>
        <p>A clear, four-step journey from valuation to sale — built for international sellers.</p>
      </header>

      <div
        className="how-it-works__track"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onFocus={() => setPaused(true)}
        onBlur={() => setPaused(false)}
      >
        <div className="how-it-works__steps" role="list">
          {STEPS.map((step, index) => {
            const Icon = step.icon;
            const isActive = activeStep === index;
            const isComplete = index < activeStep;
            const stepClass = [
              "how-it-works__step",
              isActive ? "is-active" : "",
              isComplete ? "is-complete" : "",
              !isActive && !isComplete ? "is-pending" : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <article
                key={step.titleKey}
                className={stepClass}
                role="listitem"
              >
                {index < STEPS.length - 1 ? (
                  <div className="how-it-works__segment" aria-hidden>
                    <span className="how-it-works__segment-track" />
                    {index < activeStep ? (
                      <span className="how-it-works__segment-fill is-done" />
                    ) : null}
                    {index === activeStep ? (
                      <span
                        key={playKey}
                        className="how-it-works__segment-fill is-running"
                        style={{ animationDuration: `${STEP_DURATION_MS}ms` }}
                      />
                    ) : null}
                  </div>
                ) : null}

                <button
                  type="button"
                  className="how-it-works__step-btn"
                  onClick={() => selectStep(index)}
                  aria-current={isActive ? "step" : undefined}
                  aria-label={`Step ${index + 1}: ${stripStepPrefix(home_page[step.titleKey])}`}
                >
                  <div className="how-it-works__marker">
                    <span className="how-it-works__marker-icon">
                      <Icon aria-hidden />
                    </span>
                    {isComplete ? <span className="how-it-works__marker-check" aria-hidden /> : null}
                  </div>

                  <div className="how-it-works__card">
                    <div className="how-it-works__image-frame">
                      <StepGraphic index={index} isActive={isActive} playKey={isActive ? playKey : 0} />
                    </div>
                    <h3 className="how-it-works__title">{stripStepPrefix(home_page[step.titleKey])}</h3>
                    <p className="how-it-works__desc">{trim(home_page[step.descKey])}</p>
                    {isActive ? (
                      <span className="how-it-works__progress-bar" aria-hidden>
                        <span
                          key={playKey}
                          className="how-it-works__progress-fill"
                          style={{ animationDuration: `${STEP_DURATION_MS}ms` }}
                        />
                      </span>
                    ) : null}
                  </div>
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Howwork;
